import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const achievementTokensApiSlice = createApi({
    reducerPath: 'achievementTokensApiSlice',
    baseQuery: fetchBaseQuery({ baseUrl: '/' }),
    tagTypes: ['Tokens'],
    endpoints: (builder) => ({
        getTokens: builder.query({
            query: () => '/api/achievement-tokens',
            providesTags: ['Tokens'],
        }),
        createToken: builder.mutation({
            query: (token) => ({
                url: '/api/achievement-tokens',
                method: 'POST',
                body: token,
            }),
            invalidatesTags: ['Tokens'],
        }),
        assignToken: builder.mutation({
            query: ({ tokenId, studentIds }) => ({
                url: `/api/achievement-tokens/assignments`,
                method: 'POST',
                body: { tokenId, studentIds },
            }),
            invalidatesTags: ['Tokens'],
        }),
        createAndAssignToken: builder.mutation({
            query: (data) => ({
                url: '/api/achievement-tokens/assignments/create-and-assign',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Tokens'],
        }),
        getLibraryTokens: builder.query({
            query: () => '/api/achievement-tokens/library',
        }),
        getAchievementTokenDetails: builder.query({
            query: (id) => `/api/achievement-tokens/${id}`,
        }),
        getSharedTokenDetails: builder.query({
            query: (id) => `/api/achievement-tokens/library/${id}`,
        }),
        getTokenImageUrls: builder.query({
            query: () => '/api/achievement-tokens/images',
            transformResponse: (response) => response.images,
            keepUnusedDataFor: Infinity,
        }),
        getSkillTags: builder.query({
            query: () => '/ccm/api/v2/skill-tags',
        }),
        getOntologyTags: builder.query({
            query: ({ search }) => ({
                url: '/ccm/api/v2/ontology-skills/search',
                params: { searchQuery: search.toString() },
            }),
            transformResponse: (response) => response.map(({ id, name }) => ({
                idOntology: id,
                name,
                id: 0,
                alternateName: null,
            })),
            keepUnusedDataFor: 60,
        }),
        deleteToken: builder.mutation({
            query: ({ tokenId }) => ({
                url: `/api/achievement-tokens/${tokenId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Tokens'],
        }),
        shareToken: builder.mutation({
            query: ({ tokenId }) => ({
                url: `/api/achievement-tokens/library`,
                method: 'POST',
                body: { tokenId },
            }),
            invalidatesTags: ['Tokens'],
        }),
        getTeacherStudents: builder.query({
            query: () => '/api/achievement-tokens/teacher-students',
        }),
        getStudentThumbnails: builder.query({
            query: ({ webuserIds }) => ({
                url: '/api/learnerprofile/profile-image/thumbnails/presigned-urls',
                params: { webuserIds: webuserIds.join(',') },
            }),
        }),
    }),
});
export const { matchFulfilled: matchGetSkillTagsFulfilled, matchPending: matchGetSkillTagsPending, matchRejected: matchGetSkillTagsRejected, } = achievementTokensApiSlice.endpoints.getSkillTags;
export const { useGetTokensQuery, useCreateTokenMutation, useAssignTokenMutation, useCreateAndAssignTokenMutation, useGetLibraryTokensQuery, useGetTokenImageUrlsQuery, useGetSkillTagsQuery, useLazyGetOntologyTagsQuery, useGetAchievementTokenDetailsQuery, useGetSharedTokenDetailsQuery, useDeleteTokenMutation, useShareTokenMutation, useGetTeacherStudentsQuery, useGetStudentThumbnailsQuery, } = achievementTokensApiSlice;
